
























import Vue from 'vue'
import * as R from 'ramda'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IAccountCertificateDrivingInput } from '@/modules/AccountCertificate/interfaces/account-certificate-form'
import { dateToDisplay } from '@/utils/dateTime'
@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class AccountCertificateFormDriving extends Vue {
  @Prop({ type: Object as () => IAccountCertificateDrivingInput }) value!: IAccountCertificateDrivingInput

  R = R

  get today () {
    return this.$moment().format('YYYY-MM-DD')
  }

  dateToDisplay= dateToDisplay

  validate () {
    return true
  }
}
